import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.VIDEO.AUTOPLAYED.SET',
};

export const setAutoPlayed = createAction(NAMES.SET);
